import TextChunk from './TextChunk';

export default TextChunk;
